import { useSelector } from 'react-redux';
import { AppState } from '../types/state/AppState'

export function useAppSelector<T>(selector: (s: AppState) => T) {
    return useSelector(selector);
}
